import React from "react";

//Custom Components
import PrijevozniciPage from "UI/AppPage/PrijevozniciPage";
import ResponsiveBox from "UI/Box/ResponsiveBox";
import VozaciTable from "Views/Prijevoznici/Vozaci/VozaciTable";

const PrijevozniciVozaciPage = React.memo((props) => {
  return (
    <PrijevozniciPage>
      <ResponsiveBox fillHeight>
        <VozaciTable />
      </ResponsiveBox>
    </PrijevozniciPage>
  );
});

export default PrijevozniciVozaciPage;
